import { Controller } from '../common/Controller'
import { Helper } from '../common/helpers/Helper'
import { RoleHelper } from '../common/helpers/RoleHelper'
import { AppHelper } from './AppHelper'

export class AppRoleHelper extends RoleHelper {

  getHome(orgUnitId) {
    orgUnitId = orgUnitId || this.getOrgUnitId()
    if (!Controller.get().userMgr().isInOrgUnit(orgUnitId) && !this.isProductSU()) {
      this.setCurrentOrgInfo('', '')
      orgUnitId = this.getOrgUnitId()
    }
    const {orgId, subOrgId} = AppHelper.parseOrgUnitId(orgUnitId)
    this.setCurrentOrgInfo(orgId, orgUnitId)
    if (this.isProductSU()) {
      return '/admin'
    }
    if (!subOrgId && (this.hasOrgRole(orgUnitId, 'SUPERUSER') || this.hasOrgRole(orgUnitId, 'VIEWER'))) {
      if(window.innerWidth < 1024) {
        return AppHelper.getRouteWithDefaultFilter(orgId, '/admin/orgs/' + orgId + '/crm-contacts', 'CRM_CONTACT_DEFAULT_FILTER')
      }
      return '/admin/orgs/' + orgId
    }
    if (this.hasOrgRole(orgUnitId, 'BLOGGER')) {
      if(Helper.isMobileView()) {
        return '/no-permission'
      }
      return '/admin/orgs/' + orgId
    }
    if (this.hasOrgRole(orgUnitId, 'CRM')) {
      return AppHelper.getRouteWithDefaultFilter(orgId, '/admin/orgs/' + orgId + '/crm-contacts', 'CRM_CONTACT_DEFAULT_FILTER')
    }
    if (this.isPartnerSU()) {
      return '/admin/partners/' + orgId
    }
    return '/no-permission'
  }

  async getHomeWithLoadedSettings(orgUnitId) {
    orgUnitId = orgUnitId || this.getOrgUnitId()
    const {orgId} = AppHelper.parseOrgUnitId(orgUnitId)
    if (orgId) {
      await Controller.get().cdpHelper().loadSettings(orgId)
    }
    return this.getHome(orgUnitId)
  }

  isAccessAllowed(options) {
    if (this.isProductSU()) {
      return true
    }
    if (this.isOrgSU() && (options.path.startsWith('/admin/orgs/' + this.getOrgId()))) {
      return true
    }
    if (this.isPartnerSU() && (
      options.path === ('/admin/partners/' + this.getOrgId())
    )) {
      return true
    }
    return false
  }
}
